import * as z from "zod";
import { decimal } from "../index";
import { extractionStatuses } from "./enums";

// The reading of the packing list of an inbound by the extraction tool (50-api/procurement.md §2.6.6; FR-M11-03/04,
// B-50, ADR-233): the PDF goes to the tool through TIL (I-35), its lines come back each with a confidence (I-36).
// The lines the tool is sure of, with an invoice that adds up, are the packing list; the others wait for Logistics,
// who confirms or corrects them. Then the three-way check as for a packing list typed by hand.

/**
 * What sent the lines of a reading to Logistics, or why the reading failed (`procurement.inbound.extraction_issues`):
 * the threshold as the parameter said when the lines arrived, the lines below it, and the lines at the PO cost against
 * the invoice when they do not add up to the cent (the rule of the three-way check, ADR-131).
 */
export const extractionIssues = z.object({
  threshold: z.number().min(0).max(1),
  lowConfidenceLines: z.number().int().min(0),
  invoiceMismatch: z.object({ linesTotal: decimal, invoiceTotal: decimal }).nullable(),
  /** Why the tool could not read the files, or why the request never reached it. */
  failure: z.string().nullable(),
});
export type ExtractionIssues = z.output<typeof extractionIssues>;

/** The reading of the packing list of an inbound, the latest one: only Tomorrow reads it (ADR-233). */
export const extractionDto = z.object({
  status: z.enum(extractionStatuses),
  /** The requests made so far: the result of the latest one is the only one that applies. */
  revision: z.number().int(),
  requestedAt: z.iso.datetime().nullable(),
  extractedAt: z.iso.datetime().nullable(),
  issues: extractionIssues.nullable(),
});
export type ExtractionDto = z.output<typeof extractionDto>;
